import { jsx as a } from "react/jsx-runtime";
import { Tabs as o } from "@chakra-ui/react";
function b({ children: s, variant: m = "default", ...r }) {
  return /* @__PURE__ */ a(
    o,
    {
      variant: m,
      size: { base: "sm", md: "md" },
      ...r,
      children: s
    }
  );
}
export {
  b as Tabs
};
